export default "__VITE_PUBLIC_ASSET__0ec1b55c__"